// extracted by mini-css-extract-plugin
export default {"button":"Button_button__JBBzO","withIcon":"Button_withIcon__O0jmK","small":"Button_small__jToKs","text":"Button_text__Rk+Tr"};